"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notice = void 0;
const notice = exports.notice = ['codeInputLimitReached', 'TemporaryBlock', 'PermanentBlock'];